/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Who_Pr_1Inputs */

const en_fc_vs_who_pr_1 = /** @type {(inputs: Fc_Vs_Who_Pr_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deliver client work on deadlines where stability is non-negotiable`)
};

/**
* | output |
* | --- |
* | "deliver client work on deadlines where stability is non-negotiable" |
*
* @param {Fc_Vs_Who_Pr_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_who_pr_1 = /** @type {((inputs?: Fc_Vs_Who_Pr_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Who_Pr_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_who_pr_1(inputs)
});
export { fc_vs_who_pr_1 as "fc.vs.who.pr.1" }